/** @module SiteAdmin/SelectSet/_StructureItemsMixin */
define([
	"dojo/_base/declare",
	"csi/config",
	"csi/config/preferences",
	"csi/def"
], function(declare,config,configPreferences,def) {

	return declare(null, {
		/**
		 * Add path hints and separate custom views based on SelectSet subtype
		 */
		_resolveView: function() {
			var node = this.getViewNode();
			var subtype;
			
			if (node) {
				// normal use case of loading view with root node
				// FIX: can't use csi/config in this case as SelectSet subtypes are not in reflection cache - not sure why???
				//subtype = config.getSubtypeName(node.Subtype);
				subtype = node.Subtype.slice("centric://REFLECTION/INSTANCE/SelectSetSubtype/".length); 
				this.prefKey = this.defView.getKey(subtype);
			} else if (this.customViewMigrationContainerKey) {
				// custom view migration use case of loading view with prefKey already defined
				subtype = def.decomposeViewKey(this.customViewMigrationContainerKey).context;
			}
			
			this.relRoot.pathHintsContext = configPreferences.getContextualPathHints("SelectSetItem." + subtype);

			// localize the Action based on the Hierarchy
			const aggregateAction = this.defView.getRelationships()[0].getAction("SelectHierarchySelectSetItem");

			if (aggregateAction) {
				aggregateAction.m_id = `Select${subtype}SelectSetItem`;
			}
			
			this.inherited(arguments);
		}
	});
});